module.exports = __webpack_public_path__ + "img/share_tw.765ba45a.png";